interface AuthHeaderProps {
  title: string;
  subtitle?: string;
  showBrand?: boolean;
}

export function AuthHeader({ title, subtitle, showBrand = true }: AuthHeaderProps) {
  return (
    <div className="mb-6 flex flex-col items-center gap-4">
      {showBrand && <img src="/logo.png" alt="DANGIL" className="w-[120px] h-auto" />}
      {title && !showBrand && (
        <h1 className="font-heading text-2xl font-semibold tracking-tight text-neutral-900">
          {title}
        </h1>
      )}
      {title && showBrand && <h1 className="sr-only">{title}</h1>}
      {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
    </div>
  );
}
